<template>
  <div id="counthome">
    <div class="countLeft">
      <!-- <div class="control-tips">
        系统消息：回馈老用户推出AI魔镜商城版3个月免费试用版本。
      </div> -->
      <div class="countBlock">
        <div @click="go('/skinmgr/recordsList', $i18n.t('skintest'))" class="countTest">
          <span>{{$t("count.test_tody")}}</span>
          <span class="countText"><i>{{countRecord}}</i>{{$t("ci")}}</span>
          <span>{{$t("count.test_yestoday")}}<i>{{countRecordYestoday}}</i>{{$t("ci")}}</span>
        </div>
        <div @click="go('/skinmgr/recordsList', $i18n.t('device'))" class="countDevice">
          <span>{{$t("count.today_device")}}</span>
          <span class="countText"><i>{{countDevice}}</i>{{$t("tai")}}</span>
        </div>
        <div @click="go('/skinmgr/memberList', $i18n.t('seller'))" class="countDG">
          <span>{{$t("seller")}}</span>
          <span class="countText"><i>{{countDG}}</i>{{$t("wei")}}</span>
        </div>
        <div @click="go('/skinmgr/goodsList', $i18n.t('goods'))" class="countGoods">
          <span>{{$t("goodscount")}}</span>
          <span class="countText"><i>{{countGoods}}</i>{{$t("jian")}}</span>
        </div>
        <span style="clear:left;"></span>
      </div>
      <div class="listBlock">
        <div class="hasTodo">
          <h2>{{$t("waite_do")}}</h2>
          <div v-if="worklist.wait_to_work" @click="gotoWaitWork('/skinmgr/deviceDgManager', $i18n.t('seller'))" class="todoItem">{{worklist.wait_to_work.name}}<i></i><span>{{worklist.wait_to_work.count}}</span></div>
          <div v-if="worklist.wait_to_addgoods" class="todoItem">{{worklist.wait_to_addgoods.name}}<i></i></div>
          <div v-if="!worklist.wait_to_work && !worklist.wait_to_addgoods" class="todoItem">{{$t("nodata")}}</div>
        </div>
        <div class="listDG">
          <h2>{{$t("sellstatus")}}</h2>
          <el-table class="listData" :data="lists" style="width: 5.4rem;height: auto">
            <el-table-column prop="user_acct" :label="$i18n.t('support_username')"></el-table-column>
            <el-table-column prop="mobile" :label="$i18n.t('support_mobile')" ></el-table-column>
            <el-table-column prop="yestoday" :label="$i18n.t('yestoday')" width="90"></el-table-column>
            <el-table-column prop="today" :label="$i18n.t('today')" width="70"></el-table-column>
            <el-table-column prop="shop" :label="$i18n.t('count.shop')" ></el-table-column>
            <el-table-column prop="last_device" :label="$i18n.t('count.last_device')" ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <div class="countRight">
      <div class="wechat">
        <h2>{{$t("bindwechat")}}</h2>
        <div class="ctext">
          {{$t("bindwechat_tips")}}
        </div>
        <el-button @click="goSetQr()" size="small" class="btn1">{{$t("tobind")}}</el-button>
      </div>
      <div class="help">
        <h2>{{$t("help")}}</h2>
        <div class="help_ad"></div>
        <span>{{$t("help_tips")}}</span>
      </div>
    </div> -->
    <el-dialog
      :title="$i18n.t('tips')" :visible.sync="dialogVisible" width="30%">
      <span>{{$t("tips_tips")}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t("normal_cancle")}}</el-button>
        <el-button type="primary" @click="sureGotoWaitWork">{{$t("normal_sure")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'counthome',
  data () {
    return {
      configType: this.$i18n.t('simple_model'),
      lists: [],
      doing: false,
      countRecord: 0,
      countRecordYestoday: 0,
      countDevice: 0,
      countDG: 0,
      countGoods: 0,
      worklist: {
        wait_to_work: null,
        wait_to_addgoods: null
      },
      dialogVisible: false,
      surePathStr: '',
      menushowStatus: {},
      modelType: 1
    }
  },
  computed: {

  },
  created () {
     this.getCount()
    // this.getUserInfo()
  },
  methods: {
    getCount () {
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {}
      this.axios.post('/skinMgrSrv/count/about', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.countRecord = response.data.countRecord
          _this.countRecordYestoday = response.data.countRecordYestoday
          _this.countDevice = response.data.countDevice
          _this.countDG = response.data.countDG
          _this.countGoods = response.data.countGoods
          _this.worklist.wait_to_work = response.data.worklist.wait_to_work
           _this.worklist.wait_to_addgoods = response.data.worklist.wait_to_addgoods
          _this.lists = response.data.dglist
        }
        console.log(response.data)
      })
    },
    goSetQr () {
      localStorage.activeName = 'second'
      localStorage.activeMenu = this.$i18n.t('qrset')
      this.$router.push({ path: '/skinmgr/qrbaseset'})
    },
    gotoWaitWork (pathstr, text) {
      if (this.modelType == 1) {
        this.dialogVisible = true
      } else {
        this.go(pathstr, text)
      }
    },
    sureGotoWaitWork () {
      this.dialogVisible = false
      this.go('/skinmgr/configType', this.$i18n.t('normal_set'))
    },
    go (pathstr, text) {
      if(pathstr == '/skinmgr/deviceDgManager'){
        // if(!this.menushowStatus.isShowDaogou){
        //   this.$message(this.$i18n.t('nohavepower'));
        //   return false;
        // }
      }
      if(pathstr == '/skinmgr/goodsList'){
        // if(!this.menushowStatus.isShowGoods){
        //   this.$message(this.$i18n.t('nohavepower'));
        //   return false;
        // }
      }
      if (text) {
        localStorage.activeMenu = text
      }
      this.$router.push({ path: pathstr})
    },
    getUserInfo() {
      // var info = sessionStorage.userInfo
      // info = JSON.parse(info)
      // _this.configStype = info.user_type == 10 ? 1 : 0
      // _this.menushowStatus.isShowGoods = true
      // _this.menushowStatus.isShowConfig = true
      // _this.menushowStatus.isShowSell = true
      // if (info.user_type == 10) {
      //   _this.menushowStatus.isShowDaogou = true
      // }
    }
  }
}
</script>
<style  lang="scss">
  #counthome{
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
  }

</style>

<style scoped lang="scss">
  #counthome {
    margin-top: 0.16rem;
    padding: 0rem 0.16rem;
    box-sizing: border-box;
    display: block;
    height: 100%;
    position: relative;
    .countLeft{
      vertical-align: top;
      width: 100%;
      height: 100%;
      display: inline-block;
      div.control-tips{
        padding-top: 0.0833rem;
        border:1px solid #57AEC9;
        border-radius: 0.04166rem;
        height: 0.25rem;
        margin-top:0.1667rem;
        color: #57AEC9;
        font-size: 0.116rem;
        padding-left: 0.1667rem;
        width: calc(100% - 0.32rem);
      }
      .countBlock{
        width: calc(100% - 0.15rem);
        height: 1.667rem;
        display: block;
        vertical-align: top;
        div{
          width: calc(25% - 0.1rem);
          margin-right: 0.13rem;
          height: 1.375rem;
          border-radius: 0.04166rem;
          display: inline-block;
          background-color: #57AEC9;
          padding-top: 0.29rem;
          margin-bottom: 0.08rem;
          vertical-align: top;
          cursor: pointer;
          span{
            font-size: 0.15rem;
            color: #fff;
            margin-left: 0.4167rem;
            display: block;
            margin-bottom: 0.1667rem;
          }
          span.countText{
            font-size: 0.29rem;
          }
        }
        .countDevice{
          background-color: #5792C9;
        }
        .countDG{
          background-color: #4760BA;
        }
        .countGoods{
          background-color: #433E8C;
          margin-right: 0;
        }
      }
      .listBlock{
        width: 100%;
        height: auto;
        margin-top: 0.1667rem;
        div{
          width: calc(50% - 0.16rem);
          height: 3.5rem;
          background-color: #fff;
          border-radius: 0.04166rem;
          display: inline-block;
          margin-right: 0.15rem;
          vertical-align: top;
          h2{
            color: #000;
            font-size: 0.15rem;
            margin-left: 0.3333rem;
            margin-top: 0.25rem;
          }
          .todoItem{
            float: none;
            width: calc(100% - 0.7rem);
            height: 0.5rem;
            border: 1px solid #ccc;
            margin-left: 0.3333rem;
            margin-top: 0.1667rem;
            line-height: 0.5rem;
            color: #333;
            font-size: 0.1333rem;
            padding-left:0.1rem;
            cursor: pointer;
            i{
              display: inline-block;
              width: 0.158rem;
              height: 0.24rem;
              float: right;
              background-image: url(../assets/img/for_right.png);
              background-repeat: no-repeat;
              background-position: center;
              margin: 0.125rem;
            }
            span{
              width: 0.25rem;
              height: 0.25rem;
              line-height:0.25rem;
              font-size: 0.116rem;
              color: #fff;
              background-color: #F35C5D;
              border-radius: 0.125rem;
              float: right;
              text-align: center;
              margin-top: 0.125rem;
            }
          }
        }
        div.listDG{
          min-height: 3.5rem;
          height: auto;
          margin-right: 0rem;
          .listData{
            margin-left: 0.3333rem;
            margin-top: 0.0833rem;
            font-size: 0.11rem;
          }
        }
      }
    }
    .countRight{
      width: 2.166rem;
      height: auto;
      vertical-align: top;
      display: inline-block;
      div{
        width: 100%;
        height: 2.5rem;
        display: block;
        background-color: #fff;
        border-radius: 0.04166rem;
        padding-top:0.1667rem;
        h2{
          font-size: 0.15rem;
          margin: 0px 0.1667rem;
          color: #000;
        }
        div{
          font-size: 0.116rem;
          color: #333;
          margin: 0px 0.1667rem;
          height: auto;
        }
        .ctext{
          width: 1.8rem;
        }
      }
      .shop{
        height: auto;
        color: #333;
        .line{
          width:1.667rem;
          height: 1px;
          border-top: 1px solid #ddd;
          margin: 0.1667rem auto 0.0833rem;
          padding-top: 0px;
        }
        h3{
          font-size: 0.1333rem;
          margin: 0px 0.1667rem;
          color: #000;
        }
        .manager{
          margin: 0px;
          margin-top: 0px;
          padding: 0 0 0.08rem 0;
          width: 100%;
          height: 100%;
        }
        .manager_text{
          vertical-align: top;
          width: 0.8rem;
          height: 0.5rem;
          text-align: left;
          display: inline-block;
          margin: 0;
          span{
            margin-top: 0.125rem;
          }
          span.name{
            font-size: 0.125rem;
            color: #000;
          }
        }
        .manager_qr{
          width: 0.65rem;
          height: 0.5rem;
          display: inline-block;
          background-image: url(../assets/img/manager_qr.png);
          background-repeat: no-repeat;
          background-position: center;
          margin-top: 0.08rem;
          margin-bottom: 0.08rem;
          vertical-align: top;
        }
      }
      .wechat{
        height: auto;
        margin-top: 0.0833rem;
        padding-bottom: 0.09rem;
      }
      .help{
        height: 1.25rem;
        margin-top: 0.0833rem;
        .help_ad{
          width: 1.83rem;
          height: 0.5833rem;
          background-image: url(../assets/img/helpad.png);
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
        span{
          font-size: 0.11rem;
          color: #333;
          margin: 0.0833rem auto 0.0833rem 0.1667rem;
        }
      }
      .news{
        margin-top:0.0833rem;
        height: auto;
        padding-bottom: 0.1667rem;
        ul{
          margin-left: 0.3333rem;
          margin-top: 0.1667rem;
          list-style-type: square;
          li{
            font-size: 0.116rem;
            color: #333;
            line-height: 200%;
          }
        }
      }
    }
    .btn1{
      margin-top: 0.1667rem;
      margin-left:0.1667rem;
      background-color: #57AEC9;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/default/count.vue